(function () {
  const form = document.getElementById('NbIntPopupLocalization');
  if (!form) return;
  const messages = form.querySelector('[data-nb-int-popup-messages]').dataset;
  const trackingKeys = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
    'utm_source_platform', 'utm_creative_format', 'utm_marketing_tactic',
    'gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid', 'dclid', 'srsltid',
    'fbclid', 'ttclid', 'msclkid', 'epik', 'ScCid', 'sccid', 'twclid', 'li_fat_id', 'rdt_cid', '_kx'
  ];
  // 1Click popup title -> where its CTA should take the shopper. The app's own CTA only opens a
  // link and never switches country, so the theme's market redirect bounced shoppers back.
  //   pick:     detected (IP) country -> country to switch to
  //   fallback: used when Shopify does not accept the switch (country outside the market, e.g. IS, RS);
  //             an /en-de path makes Shopify open the EU market on its own.
  const campaigns = {
    'Seems like you are an International shopper.': {
      product: '/products/nanobag-int',
      pick: (detected) => (detected === 'IN' ? 'US' : detected)
    },
    'Seems like you are a European shopper.': {
      product: '/products/nanobag-eu',
      pick: (detected) => detected,
      fallback: '/en-de/products/nanobag-eu'
    }
  };
  let pending = false;

  // Did Shopify really switch to `country` and send us to the campaign's product?
  // EU countries answer with their own path (/en-nl/products/nanobag-eu) and keep the new
  // `localization` cookie scoped to that path, so the path is the proof; root markets
  // (International) answer at /products/... and are proven by the root cookie.
  function accepted(destination, country, campaign) {
    if (destination.origin !== window.location.origin) return false;
    const pathname = destination.pathname.replace(/\/$/, '');
    if (!pathname.endsWith(campaign.product)) return false;
    const prefix = pathname.slice(0, -campaign.product.length);
    if (prefix) return prefix.toLowerCase().endsWith('-' + country.toLowerCase());
    // EU (/en-xx) and AU (/en-au) pages keep their own old `localization` cookie scoped to
    // that path, so document.cookie can hold two values; accept the switch if any is the new country.
    const selected = [...document.cookie.matchAll(/(?:^|;\s*)localization=([A-Z]{2})(?=;|$)/g)].map((m) => m[1]);
    const currency = document.cookie.match(/(?:^|;\s*)cart_currency=([A-Z]{3})(?:;|$)/);
    return selected.includes(country) && !(country === 'US' && (!currency || currency[1] !== 'USD'));
  }

  document.addEventListener('click', async function (event) {
    const path = event.composedPath();
    if (!path.some(node => node.localName === 'oneclickpopup-widget')) return;
    const button = path.find(node => node.matches && node.matches('button.primary-action-button'));
    const dialog = button && button.closest('[role="dialog"]');
    const title = dialog && dialog.querySelector('#modal-announcement-title');
    const campaign = title && campaigns[title.textContent.trim()];
    if (!campaign) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    const label = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = messages.loading;
    let error = dialog.querySelector('[data-nb-country-error]');
    if (error) error.remove();
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 15000);

    try {
      const detected = await fetch('/browsing_context_suggestions.json', {
        credentials: 'same-origin',
        signal: controller.signal
      });
      if (!detected.ok) throw new Error('Country detection failed: ' + detected.status);
      const context = await detected.json();
      const detectedCountry = context.detected_values?.country?.handle;
      if (!/^[A-Z]{2}$/.test(detectedCountry || '')) throw new Error('Country detection returned no country');
      const country = campaign.pick(detectedCountry);

      const target = new URL(campaign.product, window.location.origin);
      const query = new URLSearchParams(window.location.search);
      trackingKeys.forEach(key => {
        if (query.has(key)) target.searchParams.set(key, query.get(key));
      });
      const body = new URLSearchParams(new FormData(form));
      body.set('country_code', country);
      body.set('return_to', target.pathname + target.search);
      const switched = await fetch(form.action, {
        method: 'POST',
        body,
        credentials: 'same-origin',
        signal: controller.signal
      });
      if (!switched.ok) throw new Error('Country switch failed: ' + switched.status);
      const destination = new URL(switched.url);
      if (accepted(destination, country, campaign)) {
        window.location.assign(destination.pathname + target.search);
        return;
      }
      if (campaign.fallback) {
        window.location.assign(campaign.fallback + target.search);
        return;
      }
      throw new Error('Shopify did not accept the country switch to ' + country);
    } catch (cause) {
      console.error('[Nanobag country switch]', cause);
      error = document.createElement('p');
      error.dataset.nbCountryError = '';
      error.setAttribute('role', 'alert');
      error.textContent = messages.error;
      button.parentElement.after(error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = label;
      pending = false;
    } finally {
      window.clearTimeout(timeout);
    }
  }, true);
})();
